export const TemplateColors = [
    {name: 'black', color: 'black'},
    {name: 'blue', color: 'rgb(132, 189, 219)'},
    {name: 'gray', color: 'rgb(238, 238, 238)'},
    {name: 'green', color: 'rgb(24, 187, 155)'},
    {name: 'orange', color: 'rgb(218, 92, 74)'},
    {name: 'red', color: 'red'},
    {name: 'yellow', color: 'rgb(255, 223, 96)'},
    {name: 'white', color: 'rgb(250, 250, 250)'},
    {name: 'purple', color: 'rgb(184, 75, 97)'},
];


// WEBPACK FOOTER //
// /mnt/e/apps/architect3/client/src/app/dashboard/new-project-page/template-colors.ts